import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFlatViewOrderBanner } from '../../actions/flatViewOrder';
import { FlatViewOrderTooltip } from '../../components/FlatViewOrderTooltip';
import { showOrderTooltipSelector, getFlatViewOrderStatusDescription } from '../../selectors/flatViewOrder';

export function FlatViewOrderTooltipContainer() {
  const dispatch = useDispatch();
  const showTooltip = useSelector(showOrderTooltipSelector);
  const description = useSelector(getFlatViewOrderStatusDescription);

  const close = React.useCallback(() => {
    dispatch(toggleFlatViewOrderBanner(false));
  }, [dispatch]);

  return <FlatViewOrderTooltip showTooltip={showTooltip} onClose={close} description={description} />;
}
